import React from 'react';
import './styles.css';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  onCancel, 
  title, 
  message, 
  subMessage, 
  confirmText = "Confirmar", 
  cancelText = "Cancelar" 
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div 
        className="confirmation-modal-content" 
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className="confirmation-modal-header">
          <h5 className="confirmation-modal-title">{title}</h5>
        </div>
        <div className="confirmation-modal-body">
          <p className="confirmation-modal-message">{message}</p>
          {subMessage && <p className="confirmation-modal-sub-message">{subMessage}</p>}
        </div>
        <div className="confirmation-modal-footer">
          <button 
            className="btn-confirmation-modal btn-confirmation-modal-secondary" 
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className="btn-confirmation-modal btn-confirmation-modal-primary" 
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 